import React, { useEffect, useState } from 'react';
import ContentWrapper from '../../Layout/ContentWrapper';
import { useTranslation } from 'react-i18next';
import { Col, Row, TabContent, TabPane } from 'reactstrap';
import { getUserForAdmin, getCompanyForAdmin } from '../Services/userService';
//import HelpModal from '../Components/Modals/helpModal';
import Notifications from './notifications';
import UserProfile from './userProfile';
import CompanyProfile from './companyProfile';
import SettingsMenu from './settingsMenu';
import CompanyUsers from './companyUsers';
//import AutomatedEmailSettings from './automatedEmailSettings';
import Select from 'react-select';
//import PaymentForm from '../Stripe/PaymentForm';
import ChangePasswordForm from './changePasswordForm';
import useCompanyStore from '../../../stores/companyStore';
import useAuthStore from '../../../stores/authStore';
import useUsersStore from '../../../stores/usersStore';

const Settings = ({ history, location }) => {
  const { t } = useTranslation('translations');

  const globalUser = useAuthStore((state) => state.user);
  const company = useCompanyStore((state) => state.company);

  // Zustand users store
  const users = useUsersStore((state) => state.users);
  // const fetchUsers = useUsersStore((state) => state.fetchUsers);

  const [state, setState] = useState({
    activeTab: 'profile',
    showImageUploadModal: false,
    imageUploadPurpose: '',
    showHelpModal: false,
    selectedUser: null,
    userFromDbToEdit: null,
    companyFromDbToEdit: null,
  });

  useEffect(() => {
    //fetchUsers();
    let pathName = location.pathname;
    let splitted = pathName.split('/');
    if (splitted.length === 3) {
      toggleMenuTab(splitted[2]);
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const toggleMenuTab = (tab) => {
    if (state.activeTab !== tab) {
      history.push('/settings/' + tab);
      setState((prevState) => ({ ...prevState, activeTab: tab }));
    }
  };

  // const toggleHelpModal = () => {
  //   setState((prevState) => ({ ...prevState, showHelpModal: !prevState.showHelpModal }));
  // };

  const onSelectedUserChangedByAdmin = async (item) => {
    if (globalUser.role !== 'Admin') {
      return;
    }

    if (item) {
      setState((prevState) => ({ ...prevState, selectedUser: item }));
      const { data: userFromDbToEdit } = await getUserForAdmin(item.value);
      const { data: companyFromDbToEdit } = await getCompanyForAdmin(item.value);
      setState((prevState) => ({ ...prevState, userFromDbToEdit, companyFromDbToEdit }));
    } else {
      setState((prevState) => ({
        ...prevState,
        userFromDbToEdit: null,
        companyFromDbToEdit: null,
        selectedUser: null,
      }));
    }
  };

  const getUsersForSelect = () => {
    return users.map((user) => ({
      value: user.id,
      label: `${user.firstName} ${user.lastName} (${user.email})`,
    }));
  };

  const adminActions = () => {
    return globalUser.role === 'Admin' ? (
      <>
        <Row>
          <Col lg="2">
            <div>
              <b>{t('common.ADMIN_PART')}</b>
            </div>
            <div style={{ position: 'relative', zIndex: '3' }}>
              <div style={{ width: '300px' }}>
                <Select
                  name="onSelectUserChanged"
                  value={state.selectedUser}
                  onChange={(item) => onSelectedUserChangedByAdmin(item)}
                  options={getUsersForSelect()}
                  placeholder={t('common.SELECT_USER')}
                  isClearable={true}
                />
              </div>
            </div>
          </Col>
          <Col>
            <div>
              <b>
                {t('common.SELECTED_TENANT')}: {company.tenantId}
              </b>
            </div>
          </Col>
        </Row>
        <Row>
          <hr />
        </Row>
      </>
    ) : null;
  };

  const header = () => {
    return (
      <div className="content-heading">
        <Col md={10}>
          {t('settings.SETTINGS')}
          &nbsp;
          {/* <HelpModal purpose="settingsHelp" showModal={state.showHelpModal} onToggle={toggleHelpModal} /> */}
          <small>{t('dashboard.WELCOME_BETA')}</small>
        </Col>
      </div>
    );
  };

  return (
    <ContentWrapper>
      <div>
        {header()}
        {adminActions()}
        <Row>
          <Col lg="2">
            <SettingsMenu toggleMenuTab={toggleMenuTab} activeTab={state.activeTab} />
          </Col>
          <Col lg="10">
            <TabContent activeTab={state.activeTab} className="p-0 b0">
              <TabPane tabId="profile">
                <UserProfile userFromDbToEdit={state.userFromDbToEdit} />
              </TabPane>
              <TabPane tabId="account">
                <ChangePasswordForm />
              </TabPane>
              <TabPane tabId="notifications">
                <Notifications />
              </TabPane>
              <TabPane tabId="companyProfile">
                <CompanyProfile companyFromDbToEdit={state.companyFromDbToEdit} />
              </TabPane>
              <TabPane tabId="companyUsers">
                <CompanyUsers />
              </TabPane>
              {/* <TabPane tabId="paymentOptions">
                <PaymentForm />
              </TabPane>
              <TabPane tabId="companyAutomatedEmails">
                <AutomatedEmailSettings />
              </TabPane> */}
            </TabContent>
          </Col>
        </Row>
      </div>
    </ContentWrapper>
  );
};

export default Settings;
